module.exports = __webpack_public_path__ + "img/logo.57c96b10.png";